import { FieldTypes } from "./field.types";
import { Column, FormModel } from "./form.model";
import { isEmpty } from "../libs/utils";

export function registerColumnModels() {
  FormModel.registerModel(SectionColumn);
  FormModel.registerModel(ModelColumn);
  FormModel.registerModel(FieldColumn);
  FormModel.registerModel(PageColumn);
  FormModel.registerModel(RichTextColumn);
  FormModel.registerModel(ButtonColumn);
}

export class SectionColumn extends Column {
  getRows() {
    return this.getList("Column", "Row");
  }

  hasTable() {
    return this.getList("Column", "Model").length > 0;
  }
}

SectionColumn.setOneToManyList(["Column::Row"]);

export class ModelColumn extends Column {
  getTableModel() {
    return this.getList("Column", "Model")[0];
  }

  hasTable() {
    return this.getList("Column", "Model").length > 0;
  }

  validateMinMaxRows() {
    var minRow = this.getValue("MinRow");
    var maxRow = this.getValue("MaxRow");

    if (minRow <= 0 || maxRow <= 0) {
      return true;
    } else if (!minRow && !maxRow) {
      return false;
    } else if (minRow > maxRow) {
      return true;
    }

    return false;
  }

  validateProperties() {
    var errors = super.validateProperties();
    var isInValidRange = this.validateMinMaxRows();
    if (isInValidRange) {
      errors.push("MinRow");
      errors.push("MaxRow");
    }

    return errors;
  }
}

ModelColumn.setFieldTypes({
  MinRow: FieldTypes.number,
  MaxRow: FieldTypes.number
});

ModelColumn.setOneToManyList(["Column::Model"]);

export class FieldColumn extends Column {
  getFields() {
    return this.getList("Column", "Field");
  }

  validateCreate(kind, params, refName) {
    this.validateOneToManyOnCreate(kind, refName);
  }
}

FieldColumn.setFieldTypes({
  FontSize: FieldTypes.string, // for default appearance
  Color: FieldTypes.string // for default appearance
});

FieldColumn.setOneToManyList(["Column::Field", "Column::Appearance"]);

export class PageColumn extends Column {
  getRows() {
    return this.getList("Column", "Row");
  }
}

PageColumn.setOneToManyList(["Column::Row"]);

export class RichTextColumn extends Column {}

export class ButtonColumn extends Column {
  getEvents() {
    return this.getList("Column", "Event");
  }

  validate() {
    var errors = {};
    var children = {};
    errors[this.getValue("Id")] = children;
    var fieldErrors = {};
    fieldErrors["Field"] = [];

    var propertyErrors = [];
    var childErrors = {};

    if (!this.getValue("Name")) {
      propertyErrors.push("Name");
    }

    var oneToManyErrors = this.validateOneToMany();
    if (propertyErrors.length > 0) {
      childErrors["Properties"] = propertyErrors;
    }
    if (!isEmpty(oneToManyErrors)) {
      childErrors["Children"] = oneToManyErrors;
    }
    if (!isEmpty(childErrors)) {
      childErrors["Id"] = this.getValue("Id");
      fieldErrors["Field"].push(childErrors);
      children["Children"] = fieldErrors;
    }

    return errors;
  }
}

ButtonColumn.setFieldTypes({
  Initiator: FieldTypes.kindOf("Row"),
  DisplayType: FieldTypes.string, // for button widgets display type link/button
  Name: FieldTypes.string
});

ButtonColumn.setManyToOneList([
  "Initiator::Row" // will be used to create/delete initiator column
]);

ButtonColumn.setOneToManyList([
  "Column::Permission",
  "Column::Event",
  "Button::Row" // for footer button row
]);

registerColumnModels();
